const AMOUNT_SPENT_INPUT_PATTERN = /^\d+([.,]\d+)?$/;

export const isPartialAmountSpentInput = (value: string): boolean => {
  return value === '' || /^\d*[.,]?\d*$/.test(value);
};

export const getAmountSpentValidationError = (
  value: string | number | null | undefined
): string | undefined => {
  if (value === '' || value === null || value === undefined) {
    return undefined;
  }

  const str = String(value).trim();
  if (!str) {
    return undefined;
  }

  if (!AMOUNT_SPENT_INPUT_PATTERN.test(str)) {
    return 'Enter a valid amount (e.g. 300 or 300.5)';
  }

  return undefined;
};

export const parseAmountSpentForApi = (value: string | number | null | undefined): number => {
  if (value === '' || value === null || value === undefined) {
    return 0;
  }

  const str = String(value).trim();
  if (!str) {
    return 0;
  }

  const normalized = str.replace(',', '.');
  const num = Number(normalized);
  return Number.isFinite(num) ? num : 0;
};
